import React, { Component } from "react";
import { connect } from "react-redux";
import NumberFormat from "react-number-format";
import { withRouter } from "react-router-dom"; // Need this to push to history and redirect user properly

// Components
import MonthDropdown from "../../MonthDropdown";
import YearDropdown from "../../YearDropdown";
import Modal from "../../modal/Modal";
import Button from "../../modal/Button";
import Loader from "../../utils/Loader";

// State
import { sendPayment, unsetActiveCheckoutSectionError } from "../../../store/actions/checkout";

// CSS
import "../../../css/payment.css";

// Util
import { setTransaction as setTransactionGA } from "../../../utils/google-analytics";

class PaymentSection extends Component {
	constructor(props) {
		super(props);
		this.state = {
			// card_num_1: '',
			number: "",
			name: "",
			month: "",
			year: "",
			cvv: "",
			showPaymentModal: false,
			cardType: "",
			fullCardNum: "",
			focusedCard: 1,
			expiryError: false
		};

		this.visa = /^4[0-9]*?$/;
		this.mastercard = /^(5[1-5])(\d+)?$/;
		this.americanexpress = /^(3[47])(\d+)?$/;

		this.checkCardType = this.checkCardType.bind(this);
	}

	componentDidMount() {
		this.checkCardType();
	}

	componentWillUnmount() {
		this.props.unsetActiveCheckoutSectionError("paymentErrors");
	}

	componentWillReceiveProps(nextProps) {
		// console.log('componentWillReceiveProps:', nextProps.loading)
		// If errors exist and payment isn't processing anymore
		if (this.props.loading && !nextProps.loading) {
			this.setState({ showPaymentModal: false });
		}
	}

	handleInputChange(event) {
		const { id } = event.target;
		this.setState(
			{
				[id]: event.target.value
			},
			() => {
				// See if CC has been altered
				if (id === "card_num_1" || id === "card_num_2" || id === "card_num_3" || id === "card_num_4") {
					this.checkCardType();
				}
			}
		);
	}

	handleKeyPress(event) {
		if (event.key === "Enter") {
			this.handleSubmit(event);
		}
	}

	handleSubmit(event) {
		event.preventDefault();

		if(this.state.month === '' || this.state.year === ''){
			this.setState({expiryError: true});
		} else {
			this.setState({ showPaymentModal: true, expiryError: false });
			this.props.sendPayment(this.state).then(resp => {
				// If successfully called, push the user to the receipt page
				if (resp !== undefined) {
					// Send transaction to GA
					setTransactionGA(resp.transaction);
	
					this.props.history.push("/order-summary?order=" + resp.order + "&access=" + resp.access_token);
				}
			});
		}
	}

	checkCardType() {
		this.setState({ fullCardNum: this.state.card_num_1 + this.state.card_num_2 + this.state.card_num_3 + this.state.card_num_4 }, () => {
			const { fullCardNum } = this.state;

			// Check type via regex
			if (this.mastercard.test(fullCardNum)) {
				this.setState({ cardType: "mastercard" });
			} else if (this.visa.test(fullCardNum)) {
				this.setState({ cardType: "visa" });
			} else {
				this.setState({ cardType: "" });
			}
		});
	}

	render() {
		const { loading, errors } = this.props;
		
		return (
			<div>
				<div className="delivery-heading">
					<h2>Enter card info:</h2>

					<div className="credit-card-icon-wrapper">
						<div className={"credit-card cc--mastercard" + (this.state.cardType === "mastercard" ? " active" : "")} />
						<div className={"credit-card cc--visa" + (this.state.cardType === "visa" ? " active" : "")} />
					</div>
				</div>

				<div className="shipping-form tight-form-fields">
					<div className="form-field cc-number-field">
						<label htmlFor="card-number">Card Number:</label>

						{errors.card_num && <div className="error">{errors.card_num}</div>}

						<NumberFormat format="#### #### #### ####" placeholder="1234 1234 1234 1234" id="number" value={this.state.number} onKeyPress={e => this.handleKeyPress(e)} onChange={e => this.handleInputChange(e)} />
					</div>

					<div className="form-field">
						<label htmlFor="name">Name on Card:</label>

						{errors.name && <div className="error">{errors.name}</div>}

						<input type="text" id="name" value={this.state.name} placeholder="JOHN DOE" onKeyPress={e => this.handleKeyPress(e)} onChange={e => this.handleInputChange(e)} />
					</div>

					<div className="form-field field--cvv">
						<label htmlFor="address">Expiry:</label>

						{this.state.expiryError ?
						<div className="error">Please enter an expiry month and year.</div> :
						errors.expiry && <div className="error">{errors.expiry}</div>
						}
						
						<div className="floated-field-container">
							<div className="form-field half-field">
								<MonthDropdown month={this.state.month} handleChange={value => this.setState({ month: value })} />
							</div>
							<div className="form-field half-field">
								<YearDropdown year={this.state.year} handleChange={value => this.setState({ year: value })} />
							</div>
						</div>
					</div>

					<div className="floated-field-container">
						<div className="form-field half-field field--cvv">
							<label htmlFor="cvv">Security Code:</label>

							{errors.cvv && <div className="error">{errors.cvv}</div>}

							<NumberFormat format="###" placeholder="123" id="cvv" value={this.state.cvv} onKeyPress={e => this.handleKeyPress(e)} onChange={e => this.handleInputChange(e)} />
						</div>
					</div>

					<div className="btn_container">
						{errors.general && <div className="error">{errors.general}</div>}
						<button className={"btn submit-btn" + (loading ? " loading" : "")} onClick={e => this.handleSubmit(e)} disabled={loading}>
							<span>Submit Order</span>
						</button>
					</div>

					{/* PAYMENT MODAL */}
					{this.state.showPaymentModal && (
						<Modal
							title={"Payment Processing"}
							buttons={[
								{
									type: Button,
									text: "Close",
									action: () => this.setState({ showPaymentModal: false }),
									disabled: this.props.loading
								}
							]}
						>
							{loading && <Loader />}
							{!loading && <div>Done</div>}
						</Modal>
					)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		loading: state.checkout.paymentInProcess,
		errors: state.checkout.paymentErrors
	};
};

export default withRouter(
	connect(
		mapStateToProps,
		{ sendPayment, unsetActiveCheckoutSectionError }
	)(PaymentSection)
);



// WEBPACK FOOTER //
// ./src/components/checkout/payment/PaymentSection.js